import { render, staticRenderFns } from "./complaint-apply.vue?vue&type=template&id=2c28af33&scoped=true&"
import script from "./complaint-apply.vue?vue&type=script&lang=js&"
export * from "./complaint-apply.vue?vue&type=script&lang=js&"
import style0 from "./complaint-apply.vue?vue&type=style&index=0&id=2c28af33&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c28af33",
  null
  
)

export default component.exports